import "./index.scss";

export const Grid = ({ data, onClickItem }) => {
  return (
    <div
      className="uk-child-width-1-1 uk-child-width-1-2@s uk-margin-remove-left uk-width-expand uk-height-max-medium uk-overflow-auto uk-border-rounded"
      style={{ backgroundColor: "#333333", transform: "translateY(-3px)" }}
      uk-grid=""
    >
	{// [+-] dc: expose all available fields
	data.map(({ tag, name, query, category }, index) => (
        <div key={index} className="grid-item uk-margin-remove-vertical">
          <div
            className="uk-link-heading uk-flex uk-flex-between"
            onClick={() => onClickItem({ name: tag, url: query })}
          >
            <div className="uk-light">{name}</div>
            <div className="uk-flex uk-flex-middle">
              <span className="uk-label">{tag}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
